/**
 * Conditionally shows the "Updated" date line on posts.
 * The element is hidden by default (HTML hidden attribute).
 * It is revealed only when updated_at is >= 1 hour after published_at.
 */
const revealUpdatedDate = () => {
    const ONE_HOUR_MS = 60 * 60 * 1000;
    const elements = document.querySelectorAll('.gh-updated-date[hidden]');

    elements.forEach((el) => {
        const published = el.dataset.published;
        const updated = el.dataset.updated;

        if (!published || !updated) return;

        const pubDate = new Date(published);
        const updDate = new Date(updated);

        if (isNaN(pubDate) || isNaN(updDate)) return;

        if (updDate - pubDate >= ONE_HOUR_MS) {
            el.removeAttribute('hidden');
        }
    });
};

export { revealUpdatedDate };
